import MetricTable from './MetricTable';

export default MetricTable;
